import React from "react";
import { useTranslation } from "react-i18next";

import { Elements } from "@stripe/react-stripe-js";

import CommonButton from "../../utilities/formElements/commonButton/CommonButton";

import { ISubscription } from "../../../Interfaces/SettingInterface";
import { IPaymentData } from "../../../Interfaces/CommonInterface";

import PaymentModel from "./PaymentModal";
// Real bug found + fixed 2026-08-14, live: loadStripe() used to be called
// INSIDE this component's body, so every re-render (any Redux LOGIN
// action, even ones unrelated to payment - Settings.tsx/PublicRoutes.tsx
// both dispatch LOGIN on ordinary account-record refreshes) created a
// BRAND NEW Stripe instance and handed it to <Elements stripe={...}>.
// react-stripe-js silently ignores the `stripe` prop changing after first
// render - no error, nothing - but the CardElement refs PaymentModal.tsx
// reads ended up bound to a no-longer-current Elements instance. Net
// effect, confirmed live: "Process Upgrade" did nothing at all - no
// network call, no error toast. Now imports the ONE shared instance (see
// util/stripe.ts's own comment - this exact bug existed in five separate
// files, all fixed the same way at once).
import stripePromise from "../../../util/stripe";

import Logo from "../../../assets/images/Skydive_logo_beta.svg";

export interface PaymentProps {
  className?: string;
  title?: string;
  onClose?: any;
  children?: React.ReactNode;
  closeModel?: any;
  name?: string;
  subscriptionData?: ISubscription;
  paymentMethod?: IPaymentData;
}

const Payment: React.FC<PaymentProps> = ({
  onClose,
  subscriptionData,
  paymentMethod,
}) => {
  const { t: translation } = useTranslation();

  return (
    <>
      <div className="modal show-modal common-modal">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              {/*
                "Upgrade" -> "Change" (2026-08-30).

                This modal serves BOTH directions, and it read "Upgrade Your
                Skydive Subscription" while the body of the same screen
                correctly described a scheduled downgrade - telling a customer
                who is cutting their spend that they are upgrading.

                The direction is known only by PaymentModel below, which fetches
                the proration and owns `changeType`; this shell renders before
                that call returns. Rather than plumb the value upward for a
                heading, the heading is now true in both directions. The action
                button inside already branches correctly ("SCHEDULE PLAN CHANGE"
                vs "Process Upgrade"), so the specific word still reaches the
                customer at the point it matters - the thing they click.
              */}
              <h4 className="modal-title">
                {translation("change_your_skydive_subscription")}
              </h4>
              <CommonButton
                type="button"
                className="btn-close btn-close-white"
                onClick={onClose}
                data-bs-dismiss="modal"
              />
            </div>
            <Elements stripe={stripePromise}>
              <PaymentModel
                subscriptionData={subscriptionData}
                paymentMethodData={paymentMethod}
              />
            </Elements>
            <div className="modal-footer upgrade-main-footer">
              <div className="upgrade-footer">
                <div>
                  <p>{translation("head_for_the_rarefied_air")}</p>
                  <h5>
                    {translation(
                      "upgrade_your_account_today_for_more_features"
                    )}
                  </h5>
                </div>
                <img src={Logo} alt="logo" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Payment;
